import React, { useState } from "react";
import { educationData, experienceData } from "@data/qualification";
import "./qualification.css";

const Qualification = () => {
    const [ToggleState, setToggleState] = useState(2);

    const toggleTab = (index) => {
        setToggleState(index);
    };
    return (
        <section className="qualification section" id="qualification">
            <h2 className="section__title">Career Path</h2>
            <span className="section__subtitle">My Professional Journey</span>

            <div className="qualification__container container">
                <div className="qualification__tabs">
                    <div onClick={() => toggleTab(1)} className={ToggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}>
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                        <hr />
                    </div>

                    <div onClick={() => toggleTab(2)} className={ToggleState === 2 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                    </div>
                </div>

                <div className="qualification__sections">

                    <div className={ToggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>

                        {educationData.map((education) => (
                            <div className="qualification__data" key={education.id}>

                                {education.id % 2 === 0 ? <div></div> : ''}

                                {education.id % 2 === 0 ? <div>
                                    <span className="qualification__rounder"></span>
                                    <span className="qualification__line"></span>
                                </div> : ''}

                                <div>
                                    <h3 className="qualification__title">{education.title}</h3>
                                    <span className="qualification__subtitle">{education.where}</span>
                                    <div className="qualification__calendar">
                                        <i className="uil uil-calendar-alt"></i> {education.when}
                                    </div>
                                </div>

                                {education.id % 2 === 1 ? <div>
                                    <span className="qualification__rounder"></span>
                                    <span className="qualification__line"></span>
                                </div> : ''}

                            </div>
                        ))}
                    </div>

                    <div className={ToggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>

                        {experienceData.map((experience) => (
                            <div className="qualification__data" key={experience.id}>

                                {experience.id % 2 === 0 ? <div></div> : ''}

                                {experience.id % 2 === 0 ? <div>
                                    <span className="qualification__rounder"></span>
                                    <span className="qualification__line"></span>
                                </div> : ''}

                                <div>
                                    <h3 className="qualification__title">{experience.title}</h3>
                                    <span className="qualification__subtitle">{experience.where}</span>
                                    <div className="qualification__calendar">
                                        <i className="uil uil-calendar-alt"></i> {experience.when}
                                    </div>
                                </div>

                                {experience.id % 2 === 1 ? <div>
                                    <span className="qualification__rounder"></span>
                                    <span className="qualification__line"></span>
                                </div> : ''}

                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Qualification;